import { FileCopySharp } from "@mui/icons-material";
import {
  Home,
  Box,
  Clipboard,
  Camera,
  UserPlus,
  Users,
  Chrome,
  BarChart,
  Settings,
} from "react-feather";

export const AP_ADMINMENUITEMS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  /* {
        title: 'Products', icon: Box, type: 'sub', active: false, children: [
            {
                title: 'Physical', type: 'sub', active: false, children: [
                    { path: '/products/physical/category', title: 'Category', type: 'link' },
                    { path: '/products/physical/sub-category', title: 'Sub Category', type: 'link' },
                    { path: '/products/physical/product-list', title: 'Product List', type: 'link' },
                    { path: '/products/physical/product-detail', title: 'Product Detail', type: 'link' },
                    { path: '/products/physical/add-product', title: 'Add Product', type: 'link' },
                ]
            },
            {
                title: 'digital', type: 'sub', active: false, children: [
                    { path: '/products/digital/digital-category', title: 'Category', type: 'link' },
                    { path: '/products/digital/digital-sub-category', title: 'Sub Category', type: 'link' },
                    { path: '/products/digital/digital-product-list', title: 'Product List', type: 'link' },
                    { path: '/products/digital/digital-add-product', title: 'Add Product', type: 'link' },
                ]
            },
        ]
    }, */

  /* {
    title: "User Management",
    icon: Users,
    type: "sub",
    active: false,
    children: [
      { path: "/userManagement/users", title: "User", type: "link" },
      { path: "/userManagement/group", title: "Group", type: "link" },
      { path: "/userManagement/userLog", title: "User Logs", type: "link" },
      {
        path: "/userManagement/autoImportLogs",
        title: "Auto Import Logs",
        type: "link",
      },
    ],
  }, */
  {
    title: "Master",
    icon: FileCopySharp,
    type: "sub",
    active: false,
    children: [
      { path: "/master/vendorType", title: "Vendor Type", type: "link" },
      // {
      //   path: "/master/vendorEvaluationList",
      //   title: "Vendor Evaluation",
      //   type: "link",
      // },
       {
        path: "/master/vendorRegistrationList",
        title: "Vendor Registration",
        type: "link",
      },
       {
        path: "/master/vendorAmendmentList",
        title: "Vendor Amendment",
        type: "link",
      },
      {
        path: "/master/bulk-invite",
        title: "Send Bulk Invite",
        type: "link",
      },
      { path: "/master/documentType", title: "Document Type", type: "link" },
      { path: "/master/offsetGlType", title: "Offset Gl Type", type: "link" },
      { path: "/master/paymentTerms", title: "Payment Terms", type: "link" },


    ],
  },

  {
    title: "Reports",
    //path: "/reports/report",
    icon: BarChart,
    type: "sub",
    active: false,
    children: [
      /* {
        path: "/master/balanceConfirmation",
        title: "Balance Confirmation",
        type: "link",
      },
      {
        path: "/reports/outstandingBill",
        title: "Outstanding Bill",
        type: "link",
      },

      {
        path: "/reports/openDebit",
        title: "Open Debit",
        type: "link",
      },

      {
        path: "/reports/openCredit",
        title: "Open Credit",
        type: "link",
      }, */

      {
        path: "/reports/ap/ledger",
        title: "Ledger",
        type: "link",
      },
      {
        path: "/reports/ap/vendor-documents",
        title: "Vendor Documents",
        type: "link",
      },
    ],
  },
];


export const AP_VENDORMENUITEMS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    path: "/vendorProfile",
    title: "Vendor Profile",
    icon: Users,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Reports",
    //path: "/reports/report",
    icon: BarChart,
    type: "sub",
    active: false,
    children: [
      /* {
        path: "/master/balanceConfirmation",
        title: "Balance Confirmation",
        type: "link",
      },
      {
        path: "/reports/outstandingBill",
        title: "Outstanding Bill",
        type: "link",
      },

      {
        path: "/reports/openDebit",
        title: "Open Debit",
        type: "link",
      },

      {
        path: "/reports/openCredit",
        title: "Open Credit",
        type: "link",
      }, */

      {
        path: "/reports/ap/ledger",
        title: "Ledger",
        type: "link",
      },
    ],
  },
];


export const AP_VENDORMENUITEMS_NOT_ONBOARDED = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  
];
